var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMichael(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 456,
    viewBox: "0 0 240 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.922 73.8505C128.376 69.6431 126.561 67.0719 122.477 66.1369C116.352 64.7344 103.421 59.8257 98.6569 64.0332C93.8927 68.2406 110.907 76.6555 117.033 76.6555C121.116 76.6555 124.746 75.7205 127.922 73.8505Z",
    fill: "#040404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.347 120.824C151.809 129.437 152.733 135.104 154.119 137.825C156.198 141.905 159.663 162.306 159.663 165.706C159.663 169.106 177.681 174.547 174.909 183.387C173.061 189.281 166.593 184.294 155.505 168.426L143.724 132.384V120.824H151.347Z",
    fill: "#E5C9B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.655 395.791L152.573 427.429L167.327 423.99L160.301 392.352L147.655 395.791Z",
    fill: "#E5C9B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.271 55.9701C131.474 49.0787 138.479 43.5655 138.479 37.3633C138.479 33.2284 137.778 27.2558 136.377 19.4456C128.438 11.6353 120.5 8.87871 112.561 11.1758C104.622 13.473 99.4851 17.1484 97.1502 22.2021C97.1502 26.7964 96.6832 30.2421 95.7492 32.5393C94.3483 35.985 95.7492 38.0524 98.5512 41.4981C101.353 44.9438 105.556 48.3895 100.653 66.3073C97.3837 78.2524 105.322 81.9278 124.469 77.3335C123.535 67.6855 124.469 60.5644 127.271 55.9701Z",
    fill: "#E5C9B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.99 353.887C124.287 356.152 120.584 353.435 116.881 345.735C113.178 338.035 109.012 324.447 104.384 304.97C106.698 299.988 109.012 297.497 111.327 297.497C113.641 297.497 119.196 316.294 127.99 353.887Z",
    fill: "#030303"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.679 183.348L156.065 164.338L127.206 173.164C99.2623 178.143 85.2907 181.538 85.2907 183.348C85.2907 184.966 77.3437 183.396 76.358 193.532C75.6886 200.417 75.6709 214.579 81.8551 221.369C88.0392 228.158 102.469 278.399 109.34 294.015C113.921 304.425 123.77 340.409 138.887 401.966C154.462 405.587 163.623 405.587 166.372 401.966C169.12 398.345 167.746 370.735 162.249 319.136C171.869 316.42 179.885 313.251 186.299 309.63C195.918 304.199 233.023 285.868 238.52 270.931C244.017 255.995 233.023 243.095 224.778 234.269C219.281 228.384 203.248 211.411 176.679 183.348ZM149.508 240.988C160.264 245.972 167.045 249.369 169.851 251.182C174.06 253.9 179.672 255.259 179.672 260.695C179.672 266.132 174.06 268.85 171.955 270.889C170.552 272.248 164.941 277.005 155.12 285.159L149.508 240.988Z",
    fill: "#6066A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.618 82.9898C141.906 86.1442 148.082 97.4098 158.148 116.787C155.869 118.81 154.039 120.162 152.658 120.842C151.277 121.522 148.989 122.198 145.795 122.87C146.71 132.333 148.082 139.093 149.913 143.148C152.658 149.232 165.012 174.241 149.913 178.297C134.814 182.352 121.774 180.325 114.224 183.028C106.674 185.732 88.1439 189.788 77.8491 176.269C70.9859 167.257 66.868 161.173 65.4953 158.019C57.7171 151.71 49.71 148.556 41.4742 148.556C29.1204 148.556 25.6888 145.176 25.6888 143.148C25.6888 141.12 31.8657 129.629 41.4742 119.49C51.0826 109.351 54.5142 93.8048 60.0048 88.3973C65.4953 82.9898 70.2996 72.1748 81.2807 70.147C92.2618 68.1192 98.4387 62.0358 101.184 64.0636C103.929 66.0914 108.047 76.2305 116.969 74.8786C117.385 74.8156 117.788 74.7448 118.177 74.6663L118.177 74.6663C126.355 73.0174 134.748 76.2758 139.618 82.9898Z",
    fill: "#5D6444"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.555 38.2661C137.22 39.8301 141.628 38.9487 143.653 34.1709C145.677 29.3932 145.677 24.6154 142.303 23.2503C138.929 21.8853 150.401 12.3297 137.579 4.13931C124.757 -4.05112 115.984 2.0917 111.935 4.13931C107.886 6.18692 105.187 2.0917 102.488 4.13931C99.7884 6.18692 99.1136 12.3297 95.7394 14.3774C92.3652 16.425 89.6659 19.8376 92.3652 25.2979C95.0646 30.7582 97.0891 34.8534 100.463 32.8058C103.837 30.7582 99.7884 26.663 102.488 23.2503C105.187 19.8376 104.512 16.425 109.236 19.1551C113.96 21.8853 120.033 19.1551 124.082 19.1551C128.131 19.1551 134.205 21.8853 134.205 25.2979C134.205 28.7106 133.889 36.7021 135.555 38.2661Z",
    fill: "#F3AA47"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.805 43.8558C115.173 44.9384 112.55 43.3145 110.936 38.9839",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.698 33.7806C120.678 37.5914 119.943 39.3063 117.495 38.9252",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.694 29.8744C127.006 29.8744 127.006 33.7719 125.694 33.7719C124.383 33.7719 124.383 29.8744 125.694 29.8744Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.768 26.3267C123.185 25.188 128.383 27.0834 127.966 28.2222C127.55 29.3609 122.351 27.4654 122.768 26.3267Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.558 25.3712C113.44 23.8607 108.198 25.0722 108.316 26.5827C108.433 28.0933 113.675 26.8817 113.558 25.3712Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.576 28.5842C113.887 28.5842 113.887 32.4817 112.576 32.4817C111.264 32.4817 111.264 28.5842 112.576 28.5842Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.542 41.9501C133.293 41.4552 132.46 41.4552 132.044 41.9501C131.628 42.445 132.252 43.1874 133.917 44.1772",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1348 37.1726C100.326 37.7559 101.149 37.8257 101.604 37.382C102.059 36.9383 101.506 36.168 99.9465 35.0713",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.937 37.6725C110.937 38.5392 110.499 38.9726 109.625 38.9726",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.32 54.2776C124.63 53.5661 119.11 57.835 115.66 57.835C112.21 57.835 107.38 50.0086 106 50.7201C104.62 51.4316 108.07 62.104 113.59 63.527C119.11 64.95 126.01 54.9891 125.32 54.2776Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M141.139 107.829C140.678 126.472 144.6 144.66 152.906 162.393",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.368 82.1326C120.559 83.8919 114.876 83.3641 108.319 80.5493",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.183 79.2485C109.625 78.2091 104.816 75.6108 101.756 71.4536",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5217 81.8465C80.7677 88.9988 83.3906 95.9276 83.3906 102.633",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0448 90.9423C78.86 99.0969 80.7676 104.08 80.7676 105.893C80.7676 107.705 78.1446 105.666 72.8987 99.7765",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1484 127.31C72.9698 145.903 69.9096 155.863 68.9681 157.191",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0353 111.721C67.6582 123.321 68.9697 130.683 68.9697 133.806",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.725 171.491C138.687 177.733 134.565 181.077 131.359 181.523C128.7 181.893 124.727 183.971 119.681 182.86C115.603 181.963 110.885 176.699 100.446 175.504",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2992 215.01C93.7008 210.472 90.0221 207.294 87.2631 205.479C83.1245 202.755 76.9167 193.224 74.1577 190.5C71.3986 187.777 49.3263 167.352 47.2571 164.629C45.1878 161.905 35.5311 148.97 34.1516 145.565C33.2319 143.296 43.5783 146.473 65.1908 155.097C70.7089 165.99 75.0773 172.799 78.2962 175.522C83.1245 179.607 84.5041 183.011 90.0221 184.373C95.5402 185.735 107.956 187.777 112.784 193.905C110.025 198.444 105.197 205.479 98.2992 215.01Z",
    fill: "#E5C9B0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.784 450.81H202.004C203.839 442.715 202.234 437.543 197.189 435.295C189.621 431.922 177.238 428.549 174.486 424.502C171.734 420.455 168.983 415.733 164.167 415.733C159.351 415.733 160.039 421.129 151.784 418.431C146.28 416.632 146.28 427.425 151.784 450.81Z",
    fill: "#030303"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M183.068 261.129C188.417 264.593 191.914 268.49 193.56 272.821",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M156.835 188.371C152.124 195.658 148.913 200.213 147.2 202.035C145.487 203.856 146.343 225.718 149.769 267.619",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M183.068 241.648C172.198 231.813 163.455 224.885 156.839 220.861",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.63 241.633C123.119 268.294 130.988 294.277 133.236 319.582",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M164.704 396.398C154.521 397.698 146.652 397.698 141.097 396.398",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.869 190.973C105.411 208.896 97.9789 220.155 92.574 224.751",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M175.199 188.373C170.021 188.373 163.9 186.207 156.838 181.877",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3467 154.603C51.9975 148.54 40.1942 145.509 30.9367 145.509",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M103.064 197.473C104.774 198.311 105.94 198.96 106.561 199.422C107.182 199.883 107.765 200.533 108.31 201.371",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8234 206.562C99.1061 207.4 99.9804 208.049 100.446 208.511C100.912 208.973 101.349 209.622 101.758 210.46",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M101.756 202.677C103.039 203.514 103.913 204.164 104.379 204.625C104.845 205.087 105.282 205.737 105.69 206.574",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7412 159.801C28.8085 148.253 23.4152 143.121 26.5613 144.404C29.7074 145.687 32.1793 146.115 33.9771 145.687L42.7412 159.801Z",
    fill: "#1D1D1D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3906 181.886C80.0997 177.945 77.5992 175.096 75.889 173.337C71.9878 169.325 69.0842 163.812 66.3414 159.801",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.101 179.599C175.561 184.129 174.41 186.168 171.649 185.715C168.888 185.262 166.587 183.676 164.746 180.958C161.985 175.069 159.683 170.539 157.843 167.368C156.002 164.197 156.692 164.197 159.914 167.368L175.101 179.599Z",
    fill: "#E5C9B0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.148 116.917C158.148 119.516 156.4 123.413 152.903 128.61L151.591 121.464C154.214 119.732 156.4 118.216 158.148 116.917Z",
    fill: "#010101"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M197.492 435.807C194.779 442.214 188.674 444.35 179.177 442.214C173.63 440.967 167.424 440.637 163.575 438.37C161.747 437.293 159.938 434.944 158.148 431.322",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M185.69 431.322L183.067 436.519",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M179.136 427.423L171.267 433.919",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M162.085 448.861H150.282",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1436 454.059C78.5203 454.059 88.3008 454.059 91.4852 454.059C96.2617 454.059 114.686 449.315 118.097 424.242C121.509 399.168 121.509 397.812 118.097 385.614C114.686 373.416 109.909 339.533 109.909 334.112C109.909 328.69 107.862 303.616 96.9441 294.807C86.0263 285.997 73.7437 284.642 64.873 285.319C58.9592 285.771 54.865 288.934 52.5905 294.807C43.0374 288.482 36.6686 285.319 33.4843 285.319C28.7077 285.319 29.3901 296.162 29.3901 303.616C29.3901 308.586 29.3901 316.492 29.3901 327.335C24.3861 331.401 20.0645 340.888 16.4252 355.797C10.9663 378.16 8.23682 389.003 4.825 399.168C1.41319 409.333 -1.99863 425.597 1.41319 431.696C4.825 437.795 21.8841 449.993 39.6255 452.026C51.4532 453.381 58.9592 454.059 62.1436 454.059ZM90.3607 304.656C83.5468 304.656 78.5499 304.656 75.3701 304.656C70.6003 304.656 59.0166 304.656 59.0166 298.792C59.0166 292.927 60.3794 293.578 68.5561 292.275C76.7328 290.972 79.4584 291.623 86.9537 295.533C91.9506 298.14 93.0863 301.181 90.3607 304.656Z",
    fill: "#FF4F68"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.445 427.001C111.374 416.905 113.427 409.103 111.602 403.596C108.866 395.335 89.0259 388.452 70.5543 388.452C52.0828 388.452 16.508 388.452 16.508 407.726C16.508 427.001 21.981 433.885 26.7699 438.015C31.5589 442.145 55.5034 444.899 76.7115 441.457C90.8502 439.162 100.428 434.344 105.445 427.001Z",
    fill: "#D8D8D8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M107 361.163C103.787 351.182 102.18 344.15 102.18 340.067C102.18 333.943 88.4098 318.291 80.1474 318.291C71.8851 318.291 58.1145 320.332 53.2948 320.332C48.4752 320.332 38.8358 324.416 36.0817 331.221C33.3275 338.026 27.8193 345.511 24.3767 347.553",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3643 312.337C42.5488 302.759 39.9679 296.83 37.6217 294.549C34.1024 291.129 29.8792 287.708 29.8792 291.129C29.8792 294.549 29.8792 306.179 29.8792 312.337C29.8792 318.494 26.3598 327.387 29.8792 327.387C32.2254 327.387 37.3871 322.37 45.3643 312.337Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M54.542 456C38.9565 454.768 28.6832 453.469 23.7222 452.103C15.062 449.717 13.2068 446.601 7.32868 441.709",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8223 393.648C86.8641 387.874 66.3176 386.912 36.1826 390.761",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMichael);
export default __webpack_public_path__ + "static/media/michael.9c4e8b15e9a927b062511bf25935da58.svg";
export { ForwardRef as ReactComponent };